import { h, render } from "preact";
import ProductSet from "./product-set/product-set";

class ProductFormSet extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.innerHTML = "";
    render(
      <ProductSet
        productId={this.productId}
        idPrefix={this.idPrefix}
        initialVariantId={this.initialVariantId}
      />,
      this,
    );
  }

  get productId() {
    return this.getAttribute("product-id");
  }

  get idPrefix() {
    return this.getAttribute("id-prefix");
  }

  get initialVariantId() {
    return this.getAttribute("initial-variant-id");
  }
}

if (!customElements.get("product-form-set")) {
  customElements.define("product-form-set", ProductFormSet);
}
